<template>
  <div class="wrap">
    <PayHead :mainTitle="actCurrency == '' ? '' : ('' + actCurrency.currency_short + '') + ' 余额充值'"/>
    <div class="wrapContent">
      <!-- 填写充值金额 -->
      <!-- <div class="top section">
        <h5>请输入充值金额 <span v-text="actCurrency == '' ? '' : ('(' + actCurrency.currency_short + ')')"></span></h5>
        <span>为了付款方便，您可以一次性多次充值。</span>
        <div class="moneyForm">
          <el-form :model="moneyForm" :rules="moneyRules" ref="moneyForm" label-width="0">
            <el-form-item prop="money">
              <el-input v-model="moneyForm.money" autocomplete="off" placeholder="请输入充值金额" size="medium"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div> -->
      <!-- 选择充值方式 -->
      <div class="down section">
        <h5>
          {{pc_lang.Select_Payment_Method}}
          <p>{{ `${pc_lang['BillplzTips']} ${pc_lang['EATMTips']}` }}</p>
        </h5>
        <RechargeWay :actCurrency="actCurrency"/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import {Input, Form, FormItem} from 'element-ui'
Vue.use(Input).use(Form).use(FormItem)
import * as RegExp from '@/utils/RegExp'
import { mapGetters } from 'vuex'

import PayHead from '@/components/PayHead'
import RechargeWay from '@/components/rechargeWay/RechargeWay'

export default {
  name: 'Recharge',
  components: {
    PayHead,
    RechargeWay
  },
  data() {
    var validateMoney = (rule, value, callback) => {
      if (!RegExp.money.test(value)) {
        callback(new Error(this.pc_lang.Please_enter_the_correct_amount));
      }else{
        callback();
      }
    };

    return {
      moneyForm: {
        money: ''
      },
      moneyRules: {
        money: [
          { validator: validateMoney, trigger: 'blur' }
        ]
      },
      /* 币种 */
      currency: this.$route.query.currency || 'All',

    }
  },
  computed: {
    ...mapGetters(['currencyList']),

    /* 是否有选中的币种 */
    actCurrency() {
      if (this.currency == 'All') {
        return ''
      }else{
        let item = this.currencyList.filter(obj=> {
          return obj.currency_short == this.currency
        })[0]
        return item == undefined ? '' : item
      }
    }
  },
  async mounted() {

  },
  created() {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>

.wrapContent{
  .section{
    background: #fff;
    padding: 18px 35px 22px;
    margin: 20px 0;
    @extend .border;
    >h5{
      font-size: 20px;
      display: flex;
      align-items: center;
      >p{
        flex: 1;
        margin-left: 12px;
        font-weight: 400;
        color: #f00;
      }
    }
  }
  >.top{
    >span{
      display: inline-block;
      font-size: 12px;
      margin: 14px 0;
      color: #666666;
    }
    .moneyForm{
      width: 450px;
    }
  }
}

</style>